export default __webpack_public_path__ + "assets/upload_logo_design.28b9db.png";